import * as React from 'react';
import { ReactComponent as CheckIconSVG } from '../../assets/icons/mevo/ic_check.svg';
import IconPattern, { IconProps } from './_IconPattern';

const CheckIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={CheckIconSVG} variantPlaces={1} {...props} />;
};

export default CheckIcon;
